// Steps for homepage
const onboardingSiteSteps = [
{
        element: ".main-headline",
        popover: {
            title: "🙋 <br>Let' start",
            description: '<b>This is an onboarding page</b> that helps talented people to get on board your company.',
            position: 'bottom-left',
            showButtons: true,         // Do not show control buttons in footer
        },
},
{
    element: ".timeline-wrapper",
    popover: {
        title: '🥳<br>Timeline',
        description: 'Each recruitment phase has its own page; you can switch between them here. In the red circle <div class="badge badge-timeline-red"><span>1</span></div> you can see the total number of employees who are currently going through the recruitment phase.',
        position: 'bottom-right',
        showButtons: true,
    },
},
{
    element: ".medium-editor",
    popover: {
        title: ' ',
        description: 'Page content can be edited by clicking directly on a text just like in MS Word.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".footer-bottom-fixed",
    popover: {
        title: '🥳 <br>Done!',
        description: '<b>Remember that you can return to the guide at any time</b> by clicking on the Onboardio ship icon at the bottom left.<br>',
        position: 'top-right',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'Understood',
        doneBtnText: 'Roger', // Next button text for this step
    },
},
]



export default onboardingSiteSteps
